import {IGridStatus} from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IDriver = Data.DocuContext.Driver.IDriver;

export enum DriversPagerAction {
  Active = 0,
  Inactive = 1,
  Deleted = 2
}

export interface IDriverGridData {
  Id: IGuid;
  Status: IGridStatus;
  FirstName: string;
  LastName: string;
  SourceItem: IDriver;
}
